import createRestApiClient from "../../utility/createRestApiClient";
import {
  getCookieByDomain,
  getUrlByUserDomain,
  isHyExOnPremDomain,
  safeParseJwt
} from "../../utility/utilityFunctions";

import {
  USER_INFO_LOADING,
  USER_INFO_SUCCESS,
  USER_INFO_FAILED,
  FETCH_FEATURE_FLAGS_LOADING,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE
} from "../actionTypeConstants/UserInfo";
import { getCookieData } from "../../utility/cookieHandler/handler";

const mockApiEndpoint =
  process.env.REACT_APP_USER_AUTH_URL ||
  window?._env_?.REACT_APP_USER_AUTH_URL ||
  getUrlByUserDomain(
    process.env.REACT_APP_USER_HOST_PREFIX ||
      window?._env_?.REACT_APP_USER_HOST_PREFIX
  );

const mockApiClient = createRestApiClient().withConfig({
  baseURL: mockApiEndpoint
}).client;

export function fetchUserInfo() {
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  const header = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };

  return {
    types: [USER_INFO_LOADING, USER_INFO_SUCCESS, USER_INFO_FAILED],
    promise: () =>
      mockApiClient.get(`/api/user`, {
        headers: header
      })
  };
}

export function updateUserInfo(payload) {
  let cookieName = process.env.REACT_APP_COOKIE_NAME;
  let access_token = getCookieData(cookieName);
  if (!access_token) {
    window.location.href =
      process.env.REACT_APP_LOGIN_URL || window?._env_?.REACT_APP_LOGIN_URL;
  }
  const header = {
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json"
  };

  return {
    types: [USER_INFO_LOADING, USER_INFO_SUCCESS, USER_INFO_FAILED],
    promise: () =>
      mockApiClient.post(`/api/user`, payload, {
        headers: header
      })
  };
}

export const fetchFeatureFlags = () => {
  const featureFlagHost = getUrlByUserDomain(
    process.env.REACT_APP_FEATURE_FLAG_HOST ||
      window?._env_?.REACT_APP_FEATURE_FLAG_HOST
  );

  const token = getCookieByDomain();
  const headers = {
    Authorization: "Bearer " + token,
    Accept: "application/json",
    "Content-Type": "application/json"
  };
  const featureFlagApiEndpoint = createRestApiClient().withConfig({
    baseURL: featureFlagHost
  }).client;

  const isEuRegion = window.location.hostname.includes("eu");

  return {
    types: [
      FETCH_FEATURE_FLAGS_LOADING,
      FETCH_FEATURE_FLAGS_SUCCESS,
      FETCH_FEATURE_FLAGS_FAILURE
    ],
    promise: () =>
      featureFlagApiEndpoint.post(
        `/sdk/v1/user/flags${isEuRegion ? "?region=eu" : ""}`,
        {},
        {
          headers
        }
      )
  };
};

export const fetchOnPremFeatureFlags = ({ userInfo }) => {
  const { apiToken = "", username = "" } = userInfo;
  const headers = {
    Authorization: `Basic ` + btoa(username + ":" + apiToken),
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  const sentinelApiEndpoint =
    process.env.REACT_APP_HYPERTEST_SENTINEL_API_ENDPOINT ||
    window?._env_?.REACT_APP_HYPERTEST_SENTINEL_API_ENDPOINT;
  const featureFlagApiEndpoint = createRestApiClient().withConfig({
    baseURL: sentinelApiEndpoint
  }).client;

  return {
    payload: {
      isOnPremDomain: true
    },
    types: [
      FETCH_FEATURE_FLAGS_LOADING,
      FETCH_FEATURE_FLAGS_SUCCESS,
      FETCH_FEATURE_FLAGS_FAILURE
    ],
    promise: () =>
      featureFlagApiEndpoint.get("v1.0/featureflags", {
        headers
      })
  };
};
